import {
    SET_MAZE_CONTENT,
    SELECT_MAZE_RESPONSE,
    CLEAR_MAZE_RESPONSES,
    HIGHLIGHT_MAZE_RESPONSE,
    HIGHLIGHT_MAZE_RESPONSES,
    DEHIGHLIGHT_MAZE_RESPONSES,
    MADE_FIRST_ATTEMPT,
    SET_MAZE_RESPONSES_STRUCTURE,
    SET_IS_READY_SCRIPT_PLAYED,
    SET_MAZE_SCREEN_MODE,
    CLEAR_MAZE_SCREEN_MODE,
    SET_IS_MAZE_UNTIMED,
} from './mazeActions';
import { CLEAR_FORM } from '../common/api/formsActions';
import { MODEL, PRACTICE, PASSAGE, SCROLL, MODE } from '../constants/assessmentItemType';

const contentDefaultState = {
    isDataFetched: false,
    isMazeUntimed: false,
    formId: undefined,
    totalItems: {},
    [PASSAGE]: {},
    [SCROLL]: {},
    [MODEL]: {},
    [PRACTICE]: {},
};

export const defaultState = {
    ...contentDefaultState,
    selectedResponses: {},
    isFirstAttemptMade: false,
    isReadyScriptPlayed: false,
    screenMode: MODE.ACTIVE,
};

const formatQuestions = questions =>
    questions.map(item => {
        const formatedQuestion = {
            id: item.item_id,
            possibleResponses: item.possible_responses.map(answer => ({
                id: answer.response_id,
                text: answer.response_text,
            })),
        };
        if (item.correct_response) {
            formatedQuestion.correctResponse = item.correct_response.id;
        }
        return formatedQuestion;
    });

const mazeReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_MAZE_CONTENT:
            return {
                ...state,
                isDataFetched: true,
                formId: action.content.form_id,
                totalItems: {
                    [MODEL]: action.content.total_items.model,
                    [PRACTICE]: action.content.total_items.practice,
                    [PASSAGE]: action.content.total_items.passages,
                    [SCROLL]: action.content.total_items.scroll,
                },
                [PRACTICE]: {
                    ...action.content.practice,
                    items: formatQuestions(action.content.practice.items),
                },
                [PASSAGE]: {
                    ...action.content.questions,
                    items: formatQuestions(action.content.questions.items),
                },
                [SCROLL]: {
                    ...action.content.model.scroll_model,
                    items: formatQuestions(action.content.model.scroll_model.items),
                },
                [MODEL]: {
                    ...action.content.model.line_model,
                    items: formatQuestions(action.content.model.line_model.items),
                },
            };
        case CLEAR_FORM: {
            if (action.formId !== state.formId) {
                return state;
            }
            return {
                ...state,
                ...contentDefaultState,
            };
        }
        case SELECT_MAZE_RESPONSE:
            return {
                ...state,
                isFirstAttemptMade: true,
                selectedResponses: {
                    ...state.selectedResponses,
                    [action.questionIndex]: action.responseIndex,
                },
            };
        case SET_MAZE_RESPONSES_STRUCTURE:
            return {
                ...state,
                selectedResponses: action.responsesItems,
            };
        case HIGHLIGHT_MAZE_RESPONSES:
            return {
                ...state,
                selectedResponses: action.responses,
            };
        case SET_IS_READY_SCRIPT_PLAYED:
            return {
                ...state,
                isReadyScriptPlayed: action.isPlayed,
            };
        case SET_MAZE_SCREEN_MODE:
            return {
                ...state,
                screenMode: action.screenMode,
            };
        case HIGHLIGHT_MAZE_RESPONSE:
            return {
                ...state,
                selectedResponses: {
                    ...state.selectedResponses,
                    [action.questionIndex]: action.responseIndex,
                },
            };
        case DEHIGHLIGHT_MAZE_RESPONSES:
            return {
                ...state,
                selectedResponses: defaultState.selectedResponses,
            };
        case CLEAR_MAZE_RESPONSES:
            return {
                ...state,
                isFirstAttemptMade: defaultState.isFirstAttemptMade,
                selectedResponses: defaultState.selectedResponses,
            };
        case CLEAR_MAZE_SCREEN_MODE:
            return {
                ...state,
                screenMode: defaultState.screenMode,
            };
        case MADE_FIRST_ATTEMPT:
            return {
                ...state,
                isFirstAttemptMade: true,
            };
        case SET_IS_MAZE_UNTIMED: {
            return {
                ...state,
                isMazeUntimed: action.isMazeUntimed,
            };
        }
        default:
            return state;
    }
};

export default mazeReducer;
